import RouteErrorElement from "@app/layouts/ErrorLayout/RouteErrorElement";
import AboutsUs from "@pages/AboutUs/AboutUs";
import { fetchContext } from "@sphtech/web2-core/ssr";
import { RouteObject } from "react-router";

const errorElement = import.meta.env.PROD ? <RouteErrorElement /> : undefined;

/**
 * Routes specific to SWW
 */
export const pubRoutes: RouteObject[] = [
  {
    path: "/about-us",
    element: <AboutsUs />,
    errorElement,
    loader: fetchContext,
  },
];
